import {
  useCustomEventListener,
  useExternalListener,
  useVirtualMirror,
} from '@hooks';
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Step from '../components/step';
import { useRIA } from '../modules/RIA/hooks/useRIA';
import { workflowActions } from '../redux/slices/workflow';

const Workflow = ({ backofficeConfig }: any) => {
  const currentStep = useSelector((state: any) => state.workflow.currentStep);
  // //step precedente utilizzato nel caso del carrello per gestire il goPrevStep
  // const prevStepRef = useRef(currentStep);
  const prescription = useSelector(
    (state: any) => state?.config?.prescriptionModule
  );
  let brain = window?.rxcBrain;
  const dispatch = useDispatch();

  useRIA();
  useExternalListener();
  useVirtualMirror();

  // listen to the event sent from the Brain > Workflow class, every time _currentStep is changed
  useCustomEventListener('changeStep', (e: CustomEvent) => {
    if (e.detail) {
      // nascondo lo step ad ogni cambio
      brain.setHideCurrentStep(true);
      setTimeout(() => dispatch(workflowActions.setCurrentStep(e.detail)), 0);
      console.log('STEPS: ', currentStep, brain.currentStep);
    }
  });
  useEffect(() => {
    // trigger the navigation to the first step
    !brain.currentStep && brain.goNextStep([]);
  }, []);

  useEffect(() => {
    if (prescription) {
      window.dispatchEvent(new CustomEvent('LoadPrescription'));
    } else {
      brain.setIsWaitingForPrescription(false);
    }
  }, [prescription]);

  //settare stato sono arrivato in review step
  //useEffect utile nel caso del edit dal cart per evitare che tornando negli step precedenti
  //e selezionando una opzione skippi diretto in review
  useEffect(() => {
    if (currentStep.components) {
      let reviewPanel = currentStep.components.find(
        (comp: any) => comp.id === 'RXC_REVIEW_PANEL'
      );
      if (reviewPanel) {
        brain.reviewStepReached = true;
      }
    }
  }, [currentStep]);

  //step precedente utilizzato nel caso del carrello per gestire il goPrevStep
  const prevStepRef = useRef(null);
  // Crea una ref per tenere traccia se abbiamo mai trovato l'ordine dell'ultimo step
  const foundLastOrderRef = useRef(false);

  useEffect(() => {
    console.log('###USEEFFECT', currentStep.definingAttributes?.step_id);
    const lastStepOrder =
      brain.stepChain[brain.stepChain.length - 1]?.progressive;
    // Verifica se currentStep è diverso dal precedente
    if (
      currentStep &&
      currentStep?.components &&
      currentStep?.definingAttributes &&
      prevStepRef.current !== currentStep &&
      !brain.isWaitingForPrescription
    ) {
      if (!brain.isLastStep(currentStep)) {
        // Verifica se abbiamo mai incontrato un currentStep con lo stesso order dell'ultimo step
        if (
          !foundLastOrderRef.current &&
          currentStep.definingAttributes?.order === lastStepOrder
        ) {
          foundLastOrderRef.current = true; // Aggiorna la ref una volta che la condizione è soddisfatta
        }

        if (brain.packageFromCart) {
          // Se lo step corrente ha ordine superiore allo step precedente, chiama editFromCartGoNext
          if (brain.reviewStepReached === false) {
            brain.editFromCartGoNext(currentStep, dispatch);
          } else {
            brain.checkOptionsAndGoNext(currentStep, dispatch);
          }
        } else {
          // Altrimenti, controlla le opzioni e vai avanti
          if (currentStep?.definingAttributes?.step_id !== 'MixAndMatch') {
            brain.checkOptionsAndGoNext(currentStep, dispatch);
          } else {
            brain.setHideCurrentStep(false);
          }
        }
      } else {
        // Siamo nel review step e bisogna settarlo visibile dato che non entra dentro il checkOptions
        brain.setHideCurrentStep(false);
      }
      // Aggiorna prevStepRef a currentStep per il prossimo ciclo
      prevStepRef.current = currentStep;
    }
  }, [currentStep, brain.packageFromCart, brain.isWaitingForPrescription]);

  return (
    <Router>
      <Routes>
        <Route element={<Layout data={backofficeConfig} />}>
          <Route
            path="*"
            element={
              <Step
                key={currentStep?.definingAttributes?.order}
                currentStep={currentStep}
              />
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default Workflow;
